import { render, staticRenderFns } from "./CommonText.vue?vue&type=template&id=1af17552&scoped=true"
import script from "./CommonText.vue?vue&type=script&lang=js"
export * from "./CommonText.vue?vue&type=script&lang=js"
import style0 from "./CommonText.vue?vue&type=style&index=0&id=1af17552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af17552",
  null
  
)

export default component.exports